import React, { Component } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import Card from "../../../components/common/Card.js";
import CardHeader from "../../../components/common/CardHeader.js";
import CardBody from "../../../components/common/CardBody.js";
import CardTitle from "../../../components/common/CardTitle.js";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import EditNoteIcon from "@mui/icons-material/EditNote";
import IconButton from "@mui/material/IconButton";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  InputLabel,
  TextField,
  Select,
  TableCell,
  Box,
  Button as Button_M
} from "@mui/material";
import MaterialCustomTablePagination from "../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { EnrollmentService } from "../../../service/manage/enrollment/enrollment.service.js";
import { PaymentService } from "../../../service/manage/payments/payment.service.js";
import Spinner from "react-bootstrap/Spinner";
import PageSpinner from "../../../components/common/spinner/PageSpinner.js";
import "../../../components/admin/css/common.css";
import sweetAlert, {
  sweetStatusAlert,
  sweetSuccessAlert,
} from "../../../components/common/SweetAlert.js";
import ReactSelect from "react-select";
import SimpleReactValidator from "simple-react-validator";
import { history } from "../../../helper/history.js";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import "./Payment.css";
import TimeZoneHandler from "../../../handlers/TimeZoneHandler.js";
import { OwnerRestrictedViewPayment } from "./OwnerRestrictedViewPayment.js";
import { PaymentMethodService } from "../../../service/settings/manage/payment_method.service.js";
import Dropdown from "react-bootstrap/Dropdown";
import DiscountModal from "./DiscountModal.js";
import DatePicker from "react-datepicker";
import { routes } from "../../../helper/routes.js";
import { cgcDocSubmisBlobName, compoenentRenderFrom, namespace } from "../../../helper/namespace.js";
import Tooltip from '@mui/material/Tooltip';
import { AzureStorageManage } from "../../../helper/azureStorageManage.js";
import ReceiptDocUpload from "./ReceiptDocUpload.js";
import SelecteDocsHandle from "./SelectedDocsHandle.js";


import AEHSLogo from "../../../assets/images/AEHS-Logo.png";
import EdsiderLogo from "../../../assets/images/edsiderlogo.png";
import CGCLogo from "../../../assets/images/cgc-logo.png";



const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};


// Suppose your .env or config has: REACT_APP_CUSTOMER_FEATURE_FLAG = "AEHS" or "CGC" or "edsider"
const brandFlag = process.env.REACT_APP_CUSTOMER_FEATURE_FLAG;

let brandLogo;
switch (brandFlag) {
  case "AEHS":
    brandLogo = AEHSLogo;
    break;
  case "edsider":
    brandLogo = EdsiderLogo;
    break;
  case "CGC":
    brandLogo = CGCLogo;
    break;
  default:
    // fallback
    brandLogo = CGCLogo;
}





let addBtnStyle, closeBtnStyle;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    break;
  case customerConstants.EXO_CUSTOMER2:
    closeBtnStyle = {
      color: "var(--maincolor-cmc)",
      backgroundColor: "#E5F5FF",
      borderColor: "transparent",
    };
    addBtnStyle = {
      color: "#fff",
      backgroundColor: "var(--maincolor-cmc)",
      borderColor: "transparent",
    };
    break;
  default:
    break;
}

export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showInsertModal: false,
      showModal: false,
      enrollments: [],
      isLoading: false,
      isTableDataLoading: true,
      limit: 10, // Set the desired limit
      offset: 0, // Set the desired offset
      search_term: "",
      totalEnrollments: 10,
      currentPage: 0,
      isModified: false,
      students: [],
      selectedStudentId: "",
      selectedStudentTable: "",
      selectedStudent: null,
      search_id: "",
      isStudentsLoading: false,
      isSubmitting: false,
      registration_id: "",
      editVisibility: false,
      addVisibility: false,
      sortColumn: "user_code",
      sortDirection: "desc",
      breadcrumb2: null,
      nodeTitle: null,
      flg_list_active: null,
      amount: null,
      payments: [],
      paymentLoading: true,
      enrollmentLoading: true,
      amountLoading: true,
      amountValue: "",
      paymentValue: "",
      paymentDescription: "",
      mannualReceptCode: "",
      manualReceiptFiles: [],
      otherEnrollments: [],
      form_list_id: undefined,
      user_list_restriction: null,
      paymentMethods: [],
      selectedPaymentMethod: undefined,
      showDiscountModal: false,
      studentDiscount: undefined,
      editEndDateModal: false,
      addEndDateModal: false,
      end_date: "",
      updated_end_date: "",
      payment_date: null,
      showReceiptDoc: undefined,
      container_id: undefined,
      showSelectedDocs: false
    };

    this.debouncedHandleSearch = debounce(this.getAllEnrollments, 2000);

    this.createValidationsInstance();
    this.fileInputRef = React.createRef();
  }

  createValidationsInstance() {
    this.validator = new SimpleReactValidator();
  }

  componentDidMount() {
    const {
      privilege_add,
      privilege_edit,
      breadcrumb2,
      nodeTitle,
      flg_list_active,
      form_list_id,
      user_list_restriction,
    } = this.props.state;
    this.getVisibilityCheck(privilege_add, privilege_edit);
    this.getAllEnrollments();
    this.fetchAllPaymentMethods();
    this.getAmount();
    this.setState({
      breadcrumb2: breadcrumb2,
      nodeTitle,
      flg_list_active,
      form_list_id,
      user_list_restriction,
      container_id: `${customer}_form${form_list_id}`
        .toLowerCase()
        .replace(/[^a-z0-9-]/g, "-")
        .replace(/^-+|-+$/g, "")
    });
  }

  getVisibilityCheck(privilege_add, privilege_edit) {
    if (privilege_add == "1") {
      this.setState({
        addVisibility: true,
      });
    }
    if (privilege_edit == "1") {
      this.setState({
        editVisibility: true,
      });
    }
  }

  getAmount() {
    const { mid } = this.props.state;
    PaymentService.getAmountByNode(mid)
      .then((res) => {
        if (res.success) {
          this.setState({
            amount: res.data.amounts[0],
            amountLoading: false,
            end_date: res.data.amounts[0],
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Amount Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          amountLoading: false,
        });
      });
  }

  getPayment(s_id, mid) {
    PaymentService.getPaymentByStudent(parseInt(mid), s_id)
      .then((res) => {
        if (res.success) {
          this.setState({
            payments: res.data.payments,
            studentDiscount: res.data.discount,
            paymentLoading: false,
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Amount Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          paymentLoading: false,
        });
      });
  }

  getAllEnrollments() {
    const {
      mid,
      form_list_id,
      lg_user_table_id,
      lg_user_id,
      user_list_restriction
    } = this.props.state;
    const { limit, offset, sortColumn, sortDirection, search_term } =
      this.state;
    const session_id = lg_user_id;
    const table_log_id = lg_user_table_id;
    PaymentService.getAllEnrolledStudents(
      mid,
      form_list_id,
      session_id,
      table_log_id,
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term
    )
      .then((res) => {
        if (res.success) {
          if (!!user_list_restriction && res.data.count === 1) {
            this.setState({
              selectedStudent: res.data.students[0],
              selectedStudentTable: res.data.students[0].user_table_id,
              selectedStudentId: res.data.students[0].user_id
            });
          }
          this.setState({
            enrollments: res.data.students,
            totalEnrollments: res.data.count,
          });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Enrollments Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  }

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.getAllEnrollments();
      }
    );
  };

  toggleeditEndDateModal = () => {
    const { editEndDateModal, end_date } = this.state;
    this.setState({
      editEndDateModal: !editEndDateModal,
      updated_end_date: end_date?.due_date || "",
    });
  };

  toggleaddEndDateModal = () => {
    const { addEndDateModal, end_date } = this.state;

    if (end_date === undefined) {
      sweetSuccessAlert(
        "Warning",
        "Please make sure to set an amount first.",
        "warning"
      );
    } else {
      const updatedEndDate =
        end_date && Object.keys(end_date).length !== 0
          ? end_date.due_date
          : new Date();

      this.setState({
        addEndDateModal: !addEndDateModal,
        updated_end_date: updatedEndDate,
      });
    }
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.getAllEnrollments();
      }
    );
  };


  // --------------------- PRINT HANDLER (NEW) ---------------------
  async handlePrint(enrollment) {
    try {
      const { mid } = this.props.state;
  
      // --- Enrollment Data ---
      const userCode = enrollment.user_code;
      const name = `${enrollment.first_name} ${enrollment.last_name}`;
      const appliedDiscount = enrollment?.discount
        ? `${enrollment.discount}%`
        : "None";
      const outstanding = this.calOutstandingAmount(
        this.state.amount?.amount,
        enrollment.total_amount,
        enrollment.discount
      );
      
      // If you have other info like "programName", "courseName", etc.,
      // you can add them here as well.
  
      // --- Fetch Payment History ---
      const res = await PaymentService.getPaymentByStudent(parseInt(mid), enrollment.user_id);
      if (!res.success) {
        sweetStatusAlert("Failed!", "No payment history found.", "error");
        return;
      }
      const payments = res.data.payments || [];
  
      // --- Build Table Rows for Payment History ---
      const paymentRowsHtml = payments
        .map((p) => {
          const createdAtDate = p.created_at
            ? TimeZoneHandler.convertTimeToCustomFormat(new Date(p.created_at))
            : "";
          const paymentDate = p.payment_date
            ? TimeZoneHandler.convertTimeToCustomFormat(new Date(p.payment_date))
            : "";
  
          return `
            <tr>
              <td>${createdAtDate}</td>
              <td>${paymentDate}</td>
              <td>${p.recipt_code || ""}</td>
              <td>${p.payment_method || ""}</td>
              <td>${p.manual_recipt_code || ""}</td>
              <td>${p.payment || ""}</td>
              <td>${p.description || ""}</td>
            </tr>
          `;
        })
        .join("");
  
      // --- Printed On (Date/Time) ---
      const currentDateTime = new Date().toLocaleString();
  
      // --- Build Final Print-HTML ---
      const printContents = `
        <html>
          <head>
            <title>Payment Statement</title>
            <style>
              * {
                box-sizing: border-box;
              }
              body {
                font-family: "Poppins", sans-serif;
                margin: 0;
                padding: 0;
                background: #f3f3f3;
                color: #333;
              }
              .container {
                width: 95%;
                max-width: 900px;
                margin: 20px auto;
                background: #fff;
                padding: 20px;
                border-radius: 8px;
                box-shadow: 0 0 15px rgba(0,0,0,0.1);
              }
              .header {
                display: flex;
                align-items: center;
                margin-bottom: 20px;
                border-bottom: 2px solid #eee;
                padding-bottom: 10px;
              }
              .header .logo {
                width: 200px;
                margin-right: 15px;
              }
              .header .title {
                font-size: 24px;
                font-weight: bold;
                margin: 0;
                color: #4e73df;
              }
              .print-date {
                font-size: 13px;
                color: #777;
                text-align: right;
                margin-bottom: 20px;
              }
              /* Card Section for User Details */
              .card {
                background: #fff;
                border: 1px solid #ddd;
                border-radius: 8px;
                padding: 15px 20px;
                margin-bottom: 20px;
              }
              .card h2 {
                margin-top: 0;
                font-size: 20px;
                margin-bottom: 15px;
                color: #333;
                border-left: 4px solid #4e73df;
                padding-left: 10px;
              }
              /* Label-Value rows */
              .info-row {
                display: flex;
                justify-content: space-between;
                margin-bottom: 8px;
              }
              .info-row .label {
                font-weight: 600;
                color: #555;
              }
              .info-row .value {
                color: #333;
              }
              /* Payment History Table */
              .section-title {
                font-size: 18px;
                margin: 20px 0 10px 0;
                border-left: 4px solid #4e73df;
                padding-left: 8px;
                color: #4e73df;
              }
              .table-wrapper {
                margin-bottom: 20px;
                overflow-x: auto;
              }
              table {
                width: 100%;
                border-collapse: collapse;
                margin-bottom: 10px;
              }
              table, th, td {
                border: 1px solid #ccc;
              }
              th {
                background-color: #eee;
                font-weight: 600;
                text-align: left;
              }
              td, th {
                padding: 10px;
                font-size: 14px;
              }
              /* Additional styling for “action” or last columns if needed */
              .row {
                display: flex;
                flex-wrap: wrap;
                margin: 5px 0;
              }
              .column {
                flex: 50%;
                padding: 10px;
              }
              .section-subtitle {
                margin-top: 0;
                margin-bottom: 10px;
                font-size: 16px;
                color: #333;
                font-weight: 600;
              }
              .outstanding-box {
                background-color: #f8f9fc;
                border-left: 4px solid #1cc88a;
                padding: 15px;
                margin-top: 15px;
                font-size: 16px;
              }
              .outstanding-box span {
                font-weight: 700;
              }
              /* Print adjustments */
              @media print {
                body {
                  margin: 0;
                  background: #fff;
                }
                .container {
                  box-shadow: none;
                  border: none;
                }
                .header {
                  border-bottom: 2px solid #333;
                }
              }
            </style>
          </head>
          <body>
            <div class="container">
              <!-- Header with Logo -->
              <div class="header">
                <img 
                  class="logo"
                  src="${brandLogo}" 
                  alt="AEHS Logo"
                />
                <h1 class="title">Payment Statement</h1>
              </div>
  
              <div class="print-date">Printed on: ${currentDateTime}</div>
  
              <!-- User Info Card -->
              <div class="card">
                <h2>User Information</h2>
                <div class="info-row">
                  <div class="label">User Code:</div>
                  <div class="value">${userCode}</div>
                </div>
                <div class="info-row">
                  <div class="label">Name:</div>
                  <div class="value">${name}</div>
                </div>
                <div class="info-row">
                  <div class="label">Applied Discount:</div>
                  <div class="value">${appliedDiscount}</div>
                </div>
                <div class="info-row">
                  <div class="label">Outstanding Amount:</div>
                  <div class="value">${this.amountToLRK(outstanding)}</div>
                </div>
              </div>
  
              <!-- Payment Details Card (Optional if you want more breakdown) -->
              <!--
              <div class="card">
                <h2>Payment Details</h2>
                <div class="info-row">
                  <div class="label">Some detail:</div>
                  <div class="value">Your data here</div>
                </div>
              </div>
              -->
  
              <!-- Payment History Table -->
              <h2 class="section-title">Payment History</h2>
              <div class="table-wrapper">
                <table>
                  <thead>
                    <tr>
                      <th>Date & Time</th>
                      <th>Original Payment Date</th>
                      <th>Receipt Code</th>
                      <th>Type</th>
                      <th>Manual Receipt Code</th>
                      <th>Amount</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${paymentRowsHtml}
                  </tbody>
                </table>
              </div>
            </div>
  
            <script>
              window.onload = function() {
                window.print();
                window.close();
              }
            </script>
          </body>
        </html>
      `;
  
      // --- Open and Print ---
      const printWindow = window.open("", "_blank", "width=900,height=650");
      printWindow.document.open();
      printWindow.document.write(printContents);
      printWindow.document.close();

      printWindow.onload = () => {
        setTimeout(() => {
          printWindow.focus();
          printWindow.print();
          setTimeout(() => printWindow.close(), 500);
        }, 500);
      };
      
    } catch (error) {
      sweetStatusAlert("Failed!", "Something went wrong while printing.", "error");
      console.error(error);
    }
  }
  
  // --------------------- END PRINT HANDLER ------------------------


  fetchAllPaymentMethods = () => {
    PaymentMethodService.getAllPaymentMethods().then((res) => {
      this.setState({
        paymentMethods: res.data,
      });
    });
  };

  getCurrentEnrollments = () => {
    const s_id = this.state.selectedStudentId;
    const s_t_id = this.state.selectedStudentTable;
    PaymentService.getEnrollments(s_id, s_t_id, "enrollment", "owner")
      .then((res) => {
        if (res.success) {
          this.setState({
            otherEnrollments: res.data,
          });
        } else {
          this.setState({
            otherEnrollments: [],
          });
        }
      })
      .catch(() => {
        this.setState({
          otherEnrollments: [],
        });
      })
      .finally(() => {
        this.setState({
          enrollmentLoading: false,
        });
      });
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.getAllEnrollments();
      }
    );
  };

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          // Call the debounced version of fetchStudentData
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  togglePaymentsModal = (enrollment) => {
    this.setState(
      {
        showInsertModal: true,
        selectedStudentId: enrollment?.user_id,
        selectedStudentTable: enrollment?.user_table_id,
        selectedStudent: enrollment,
        search_id: "",
        selectedPaymentMethod: undefined,
      },
      () => {
        this.getPayment(this.state.selectedStudentId, this.props.state.mid);
        this.getCurrentEnrollments();
      }
    );
  };

  toggleDiscountModal = (enrollment) => {
    this.setState({
      showDiscountModal: enrollment ? true : false,
      selectedStudentId: enrollment?.user_id,
      selectedStudentTable: enrollment?.user_table_id,
      selectedStudent: enrollment,
    });
  };

  handlePaymentMethodSelect = (meth) => {
    this.setState({
      selectedPaymentMethod: meth,
    });
  };

  calOutstandingAmount = (amount, totalAmount, discount) => {
    let outStandingAmount = amount;
    if (discount) {
      outStandingAmount =
        outStandingAmount - (outStandingAmount / 100) * parseInt(discount);
    }
    if (totalAmount) {
      outStandingAmount = outStandingAmount - totalAmount;
    }
    return outStandingAmount;
  };

  amountToLRK = (amount) => {
    return amount?.toLocaleString("en-LK", {
      style: "currency",
      currency: "LKR",
    });
  };

  truncateString = (str, maxLength) => {
    if (str.length > maxLength) {
      return str.substring(0, maxLength) + '...';
    } else {
      return str;
    }
  }

  nameCheckForFileUpload = (file) => {
    const isHaveSameName = this.state.manualReceiptFiles.some(file_ => file.name === file_.name)
    if (isHaveSameName) {
      sweetStatusAlert(namespace.FAILED, `File names are similar`, "error")
      return true
    }
    return false
  }

  sizeCheckForFileUpload = (file) => {
    if (file.size > config.fileUploadConfigs.maxFileSize) {
      sweetStatusAlert(namespace.FAILED, `File cannot be uploaded. Check the size of the file ${file.name}!`, "error")
      return true
    }
    return false
  }

  handleSelectedFiles = (e) => {
    const { name, files } = e.target
    if (this.sizeCheckForFileUpload(files)) {
      return
    }
    if (this.nameCheckForFileUpload(files)) {
      return
    }
    this.setState({ manualReceiptFiles: Array.from(e.target.files) });
  }

  clearSelectedFiles = () => {
    this.fileInputRef.current.value = null; // Clears the selected files
    this.setState({ manualReceiptFiles: [] }); // Clear state
  };

  // Helper function to read file as text
  readFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event) => {
        resolve(event.target.result);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  handleBlobsDetail = async (user_code, manualReceiptFiles) => {
    let blobIds = [];
    if (!!manualReceiptFiles.length) {
      const typeBlobDetails = await Promise.all(
        manualReceiptFiles.map(async (file, index) => {
          const name_ = file?.name;
          const blobId = cgcDocSubmisBlobName(
            name_,
            undefined,
            undefined,
            index,
            user_code,
            undefined
          );
          const readData = await this.readFile(file);
          blobIds.push(blobId);
          return {
            blobData: readData,
            blobName: blobId,
            fileName: name_
          };
        })
      );
      return {
        typeBlobDetails: typeBlobDetails,
        typeIds: blobIds,
      };
    } else {
      return {
        typeBlobDetails: [],
        typeIds: blobIds,
      };
    }
  };

  onFileUpload = async (user_code, onRegister, manualReceiptFiles) => {
    let container_id = this.state.container_id
    this.setState({ paymentLoading: true });
    const handleBlobsDetailManualReceipt = await this.handleBlobsDetail(user_code, manualReceiptFiles);
    const blobDetailsAllType = await Promise.all([
      ...handleBlobsDetailManualReceipt.typeBlobDetails,
    ]);
    const blobsDetail = blobDetailsAllType.map(detail => ({
      blob_id: detail.blobName,
      name: detail.fileName
    }))
    try {
      await AzureStorageManage.multiUploadBlob(
        container_id,
        blobDetailsAllType
      );
      onRegister(blobsDetail)
    } catch (e) {
      onRegister([])
    } finally {
      this.setState({ paymentLoading: false });
    }
  };

  submitAmount = () => {
    const {
      mid,
      lg_user_id,
      lg_user_table_id
    } = this.props.state;
    const session_id = lg_user_id;
    const table_log_id = lg_user_table_id;
    let val = parseInt(this.state.amountValue);
    let obj = [
      {
        node_mid: mid,
        amount: val,
        create_user_id: session_id,
        create_user_table_id: table_log_id,
      },
    ];
    let updateObj = {
      node_mid: mid,
      amount: val,
      create_user_id: session_id,
      create_user_table_id: table_log_id,
    };
    this.setState({ amountLoading: true });
    if (this.state.amount == undefined) {
      PaymentService.createAmount(JSON.stringify(obj))
        .then((res) => {
          if (res.success) {
            sweetStatusAlert("Success!", res.message, "success");
          } else {
            sweetStatusAlert("Failed!", res.message, "error");
          }
        })
        .catch((error) => {
          sweetStatusAlert("Failed !", "Unable to add Amount!", "error");
        })
        .finally(() => {
          // Hide loading indicator
          this.setState({ amountValue: "" });
          this.setState({ amountLoading: true });
          this.getAmount();
        });
    } else {
      PaymentService.updatePayment(
        JSON.stringify(updateObj),
        this.state.amount?.id
      )
        .then((res) => {
          if (res.success) {
            this.setState({
              amount: res.data,
              amountLoading: false,
            });
            sweetStatusAlert("Success!", res.message, "success");
          } else {
            sweetStatusAlert("Failed!", res.message, "error");
          }
        })
        .catch((error) => {
          sweetStatusAlert("Failed !", "Unable to add Amount!", "error");
        })
        .finally(() => {
          // Hide loading indicator
          this.setState({ amountValue: "" });
        });
    }
  };

  totalPaid = () => {
    let payments = this.state.payments;
    let total = 0;
    for (let i = 0; i <= payments?.length - 1; i++) {
      total = total + payments[i]?.payment;
    }
    return total;
  };

  submitPayment = () => {
    const {
      user_list_restriction,
      lg_user_id,
    } = this.props.state;
    const session_id = lg_user_id;
    let val_payment = parseInt(this.state.paymentValue);
    let val_stu_id = user_list_restriction
      ? session_id
      : this.state.selectedStudentId;
    let checkAmountValidity =
      this.calOutstandingAmount(
        this.state.amount?.amount,
        this.totalPaid() + val_payment,
        this.state.selectedStudent?.discount
      ) >= 0;

    if (!checkAmountValidity) {
      sweetStatusAlert(
        "Failed!",
        "Provided payment is exceeding the alocated amount",
        "error"
      );
      return;
    }
    if (!this.state.selectedPaymentMethod) {
      sweetStatusAlert("Failed!", "Please select a payment method", "error");
      return;
    }
    if (this.state.description?.length > 128) {
      sweetStatusAlert("Failed!", "Description character count should not exceed 128", "error");
      return;
    }
    this.onFileUpload(this.state.selectedStudent.user_code, this.onRegister, this.state.manualReceiptFiles)
  }

  onRegister = (payment_doc_details) => {
    const {
      mid,
      user_list_restriction,
      lg_user_id,
      lg_user_table_id
    } = this.props.state;
    const session_id = lg_user_id;
    const table_log_id = lg_user_table_id;
    let val_payment = parseInt(this.state.paymentValue);
    let val_stu_id = user_list_restriction
      ? session_id
      : this.state.selectedStudentId;
    let val_table_id = user_list_restriction
      ? table_log_id
      : this.state.selectedStudentTable;
    let obj = [
      {
        node_mid: mid,
        stu_id: val_stu_id,
        payment: val_payment,
        create_user_id: session_id,
        create_user_table_id: table_log_id,
        user_table_id: val_table_id,
        payment_method_id: this.state.selectedPaymentMethod.payment_method_id,
        description: this.state.paymentDescription,
        manual_recipt_code: this.state.mannualReceptCode,
        customer: customer,
        payment_date: this.state.payment_date,
        doc_details: payment_doc_details
      },
    ];
    this.setState({ paymentLoading: true });
    PaymentService.createPayment(JSON.stringify(obj))
      .then((res) => {
        if (res.success) {
          sweetStatusAlert("Success!", res.message.success, "success");
        } else {
          sweetStatusAlert("Failed!", res.message, "error");
        }
      })
      .catch((error) => {
        sweetStatusAlert("Failed !", "Unable to add Amount!", "error");
      })
      .finally(() => {
        // Hide loading indicator
        this.setState(
          {
            paymentLoading: false,
            paymentValue: "",
            paymentDescription: "",
            mannualReceptCode: "",
          },
          () => {
            this.getPayment(val_stu_id, this.props.state.mid);
            this.getAllEnrollments();
          }
        );
      });
  };

  handleSortChange = (sortColumn) => {
    // If the same column is clicked, toggle the sort direction
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.getAllEnrollments();
      }
    );
  };

  handleAmountChange = (e) => {
    let newValue = e.target.value;
    if (newValue < 0) {
      newValue = 0;
    }
    this.setState({ amountValue: newValue });
  };

  handlePaymentChange = (e) => {
    let newValue = e.target.value;
    if (newValue < 0) {
      newValue = 0;
    }
    this.setState({ paymentValue: newValue });
  };

  handlePaymentDescriptionChange = (e) => {
    this.setState({ paymentDescription: e.target.value });
  };

  handleManualReceptChange = (e) => {
    this.setState({ mannualReceptCode: e.target.value });
  };

  handleSweetAlert = (toggleFunction, modalVisibility) => {
    if (this.state.isModified) {
      sweetAlert().then((response) => {
        this.validator.purgeFields();
        this.validator.hideMessages();
        this.setState(() => ({
          [modalVisibility]: response,
          isModified: false,
        }));
      });
    } else {
      this.validator.purgeFields();
      this.validator.hideMessages();
      toggleFunction();
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState(() => ({ [name]: value, isModified: true }));
  };

  formattedDateString = (value) => {
    const dateObject = value ? new Date(value) : undefined;
    const year = dateObject && dateObject.getFullYear();
    const month = dateObject && ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
    const day = dateObject && ("0" + dateObject.getDate()).slice(-2);
    const fromattedString = `${day}-${month}-${year}`;
    return fromattedString;
  };

  formattedTimeString = (value) => {
    const time = new Date(value);
    const formattedTime = time.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
    return formattedTime;
  };

  resetDatePicker = () => {
    // Reset the date picker
    this.setState({ updated_end_date: "" });
  };

  handleDatePickerChange = (value, key) => {
    const dateObject = value ? new Date(value) : undefined;
    const year = dateObject && dateObject.getFullYear();
    const month = dateObject && ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
    const day = dateObject && ("0" + dateObject.getDate()).slice(-2);

    const hours = dateObject && dateObject.getHours(); // Get the hours (0-23)
    const minutes = dateObject && dateObject.getMinutes(); // Get the minutes (0-59)
    const seconds = dateObject && dateObject.getSeconds(); // Get the seconds (0-59)

    const formattedDateString = dateObject
      ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
      : "";

    this.setState(() => ({ [key]: formattedDateString }));
  };

  handleAdd = async () => {
    try {
      this.setState({ loadingModal: true, addEndDateModal: false });
      const { updated_end_date, amount } = this.state;
      const { mid } = this.props.state;

      if (!updated_end_date) {
        sweetStatusAlert("Failed", "Please select a due date", "error");
        this.setState({ loadingModal: false });
        return;
      }

      const due_date = {
        due_date: updated_end_date,
        node_mid: mid,
      };

      const response = await PaymentService.updateDueDate(
        JSON.stringify(due_date),
        amount.id
      );

      if (response.success) {
        this.setState({
          end_date: response.data.due_date,
          addEndDateModal: false,
        });
        sweetSuccessAlert("Success", response.message.success, "success");
        this.getAmount();
        this.setState({
          loadingModal: false,
        });
        // this.toggleaddEndDateModal();
      } else {
        sweetSuccessAlert(
          "Failed",
          "Something went wrong, please refresh the screen!",
          "error"
        );
        this.setState({ loadingModal: false });
      }
    } catch (error) {
      this.setState({ loadingModal: false });
      sweetStatusAlert("Failed", "An error occurred", "error");
    }
  };

  handleUpdate = async () => {
    try {
      this.setState({ loadingModal: true, editEndDateModal: false });
      const { updated_end_date, amount } = this.state;
      const { mid } = this.props.state;

      const due_date = {
        due_date: updated_end_date,
        node_mid: mid,
      };

      const response = await PaymentService.updateDueDate(
        JSON.stringify(due_date),
        amount.id
      );

      if (response.success) {
        this.setState({
          end_date: response.data.due_date,
          editEndDateModal: false,
        });
        sweetSuccessAlert("Success", response.message.success, "success");
        this.getAmount();
        this.setState({
          loadingModal: false,
        });
        // this.toggleeditEndDateModal();
      } else {
        sweetSuccessAlert(
          "Failed",
          "Something went wrong, please refresh the screen!",
          "error"
        );
        this.setState({ loadingModal: false });
      }
    } catch (error) {
      this.setState({ loadingModal: false });
      sweetStatusAlert("Failed", "An error occurred", "error");
    }
  };

  handlePaymentDatePickerChange = (value) => {
    const dateObject = value ? new Date(value) : undefined;
    const year = dateObject && dateObject.getFullYear();
    const month = dateObject && ("0" + (dateObject.getMonth() + 1)).slice(-2); // Adding 1 because getMonth() returns zero-based index
    const day = dateObject && ("0" + dateObject.getDate()).slice(-2);

    const hours = dateObject && dateObject.getHours(); // Get the hours (0-23)
    const minutes = dateObject && dateObject.getMinutes(); // Get the minutes (0-59)
    const seconds = dateObject && dateObject.getSeconds(); // Get the seconds (0-59)

    const formattedDateString =
      dateObject && `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    this.setState(() => ({
      payment_date: formattedDateString,
    }));
  };

  handleStudentProfileRoute = (student) => {
    const { history, state } = this.props;
    let route = routes.student_profile;
  
    if (customer === customerConstants.EDF_CUSTOMER4) {
      route = routes.reg_b_student_profile;
    }
  
    history.push({
      pathname: route,
      state: {
        ...state?.adminState,
        student
      },
    });
  };

  onToggleReceiptDoc = (payment) => {
    this.setState({
      showReceiptDoc: payment
    })
  }

  onToggleSelectedDocs = (bool) => {
    this.setState({
      showSelectedDocs: bool
    })
  }

  removeSelectedDoc = (index_) => {
    const manualReceiptModified = this.state.manualReceiptFiles.filter((item, index) => (index !== index_))
    this.setState({ manualReceiptFiles: manualReceiptModified }, () => {
      if (this.state.manualReceiptFiles.length === 0) {
        this.fileInputRef.current.value = null;
        this.onToggleSelectedDocs(false)
      }
    })
  }
  setPayments = (payments, callBack) => {
    this.setState({
      payments: payments
    }, () => {
      callBack()
    })
  }
  render() {
    const {
      enrollments,
      isTableDataLoading,
      limit,
      currentPage,
      totalEnrollments,
      breadcrumb2,
      nodeTitle,
      amountLoading,
      paymentLoading,
      enrollmentLoading,
      editVisibility,
      addVisibility,
      deleteVisibility,
      payments,
      otherEnrollments,
      user_list_restriction,
      offset,
      editEndDateModal,
      addEndDateModal,
      end_date,
      payment_date,
    } = this.state;
    this.validator.purgeFields();
    const formattedBreadcrumb = breadcrumb2
      ? breadcrumb2.replaceAll(">", " > ")
      : "";

    const CustomInput = ({ value, onClick }) => (
      <input
        className="py-2 form-control"
        onClick={onClick}
        value={value}
        readOnly
        placeholder="Select date"
      />
    );
    return (
      <div style={{ height: "90vh", overflow: "auto" }}>
        <ContentWrapper>
          <div>
            {this.props.state.path !== "node" && (
              <CardHeader>
                <p
                  className="pb-4"
                  style={{ fontSize: "10.5625px", color: "#00000099" }}
                >
                  {formattedBreadcrumb
                    ? `${formattedBreadcrumb && formattedBreadcrumb}`
                    : ""}
                </p>
                <div className="row justify-content-between">
                  <div>
                    <CardTitle cardLabel={"Payments"} />
                  </div>
                  <div>
                    {this.props.state.path === compoenentRenderFrom.STUDENT_PROFILES && <Button
                      onClick={() => this.handleStudentProfileRoute(this.props.state.adminState?.student)}
                    >
                      Back
                    </Button>}
                  </div>
                </div>
              </CardHeader>
            )}
            {user_list_restriction ? (
              <OwnerRestrictedViewPayment
                onToggleSelectedDocs={this.onToggleSelectedDocs}
                onToggleReceiptDoc={this.onToggleReceiptDoc}
                handlePaymentDatePickerChange={this.handlePaymentDatePickerChange}
                payment_date={this.state.payment_date}
                clearSelectedFiles={this.clearSelectedFiles}
                manualReceiptFiles={this.state.manualReceiptFiles}
                handleManualReceptChange={this.handleManualReceptChange}
                mannualReceptCode={this.state.mannualReceptCode}
                fileInputRef={this.fileInputRef}
                handleSelectedFiles={this.handleSelectedFiles}
                addVisibility={addVisibility}
                editVisibility={editVisibility}
                deleteVisibility={deleteVisibility}
                amount={this.state.amount?.amount}
                due_date={this.state.amount?.due_date}
                paymentValue={this.state.paymentValue}
                paymentDescription={this.state.paymentDescription}
                payments={this.state.payments}
                studentDiscount={this.state.studentDiscount}
                paymentLoading={this.state.paymentLoading}
                handlePaymentChange={this.handlePaymentChange}
                submitPayment={this.submitPayment}
                formattedDateString={this.formattedDateString}
                formattedTimeString={this.formattedTimeString}
                amountToLRK={this.amountToLRK}
                totalPaid={this.totalPaid}
                calOutstandingAmount={this.calOutstandingAmount}
                otherEnrollments={otherEnrollments}
                getPayment={(s_id, mid) => this.getPayment(s_id, mid)}
                state={this.props.state}
                handlePaymentDescriptionChange={(e) =>
                  this.handlePaymentDescriptionChange(e)
                }
                handlePaymentMethodSelect={(meth) => {
                  this.handlePaymentMethodSelect(meth);
                }}
                selectedPaymentMethod={this.state.selectedPaymentMethod}
                paymentMethods={this.state.paymentMethods}
              />
            ) : (
              <CardBody>
                {amountLoading ? (
                  <div class="d-flex justify-content-center">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : (
                  <div className="col-md-12 px-0 d-flex justify-content-between">
                    <div className="row" style={{ width: "100%" }}>
                      {editVisibility && (
                        <div className="col-md-7">
                          <h3 className="main-payment-total col-12 col-md-8 m-0">
                            Amount:{" "}
                            {this.amountToLRK(this.state.amount?.amount)}
                          </h3>
                          {/* <br /> */}
                          <div className="row main-payment-due-date col-12 col-md-8 m-0">
                            <h5>Due Date:&nbsp;</h5>
                            {this.state.amount?.due_date ? (
                              <>
                                {this.state.loadingModal ? (
                                  <div className="d-flex justify-content-center">
                                    <Spinner animation="border" role="status">
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </Spinner>
                                  </div>
                                ) : (
                                  <>
                                    <div>
                                      {this.formattedDateString(
                                        this.state.amount.due_date
                                      )}
                                    </div>
                                    &nbsp;
                                    <div>
                                      {this.formattedTimeString(
                                        this.state.amount.due_date
                                      )}
                                    </div>
                                    &nbsp;
                                    <Button
                                      onClick={this.toggleeditEndDateModal}
                                      className="btn btn-icon btn-primary btn-sm btn-xs m-1 edit-assement-btn flaticon-edit-icon"
                                      title="Edit Due Date"
                                    />
                                  </>
                                )}
                              </>
                            ) : (
                              <div>
                                {this.state.loadingModal ? (
                                  <div className="d-flex justify-content-center">
                                    <Spinner animation="border" role="status">
                                      <span className="sr-only">
                                        Loading...
                                      </span>
                                    </Spinner>
                                  </div>
                                ) : (
                                  <>
                                    &nbsp;
                                    <Button
                                      onClick={this.toggleaddEndDateModal}
                                      className="flaticon2-plus btn-sm btn-xs icon-sm mr-2"
                                      title="Add Due Date"
                                    />
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="col-md-5">
                        <Form.Group
                          controlId="exampleForm.ControlInput1"
                        // className="mb-2 d-flex justify-content-end col-md-12 col-12 px-0"
                        >
                          {editVisibility && (
                            <div className="d-flex">
                              <div className="no-arrow col-md-7 px-0">
                                <TextField
                                  type="number"
                                  size="small"
                                  value={this.state.amountValue}
                                  placeholder="Amount (LKR)"
                                  onChange={(e) => this.handleAmountChange(e)}
                                  variant="outlined"
                                  inputProps={{ min: 0 }}
                                />
                              </div>
                              <div className="d-flex align-items-center col-md-5 px-0">
                                <Button
                                  className="insert-btn set-amnt-btn"
                                  variant="primary"
                                  disabled={this.state.amountValue?.length < 1}
                                  onClick={this.submitAmount}
                                  style={{ height: "36px", marginLeft: "12px" }}
                                >
                                  {this.state.amount?.amount !== undefined
                                    ? "Update"
                                    : "Set Amount"}
                                </Button>
                              </div>
                            </div>
                          )}
                        </Form.Group>
                      </div>
                    </div>
                  </div>
                )}
                {!user_list_restriction && <br />}
                {!user_list_restriction && <br />}
                {/* {isLoading && (
                  <PageSpinner id="show" text="Loading, Please wait!" />
                )} */}

                {!amountLoading && !user_list_restriction && (
                  <Form.Group
                    controlId="exampleForm.ControlInput1"
                    className="mb-2"
                  >
                    <Form.Control
                      type="text"
                      placeholder="Search"
                      onChange={this.handleSearch}
                      isInvalid={this.state.searchError}
                      // style={{ width: "18%" }}
                      value={this.state.search_term}
                      className="col-md-3 col-12"
                    />
                    {this.state.searchError && (
                      <Form.Control.Feedback type="invalid">
                        Invalid input
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                )}
                {isTableDataLoading ? (
                  <div className="loading-container">
                    <Spinner animation="border" role="status">
                      <span className="sr-only">Loading...</span>
                    </Spinner>
                  </div>
                ) : !!enrollments.length ? (
                  <>
                    <div>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {!this.props.state?.user_list_restriction && (
                            <>
                              <TableCell className="thead">User Code</TableCell>
                              <TableCell className="thead">Name</TableCell>
                            </>
                          )}
                          <TableCell className="thead">Payment Details</TableCell>
                          <TableCell className="thead">Applied Discount</TableCell>
                          <TableCell className="thead">Outstanding Amount</TableCell>
                          <TableCell className="thead">Discount Detail</TableCell>

                          {/* -------------- NEW PRINT COLUMN (HEADER) -------------- */}
                          <TableCell className="thead">Print</TableCell>
                        </TableRow>
                      </TableHead>

                      <TableBody>
                        {enrollments.map((enrollment) => (
                          <TableRow key={enrollment.id}>
                            {!this.props.state?.user_list_restriction && (
                              <>
                                <TableCell className="tData">
                                  {enrollment.user_code}
                                </TableCell>
                                <TableCell className="tData">
                                  {enrollment.first_name + " " + enrollment.last_name}
                                </TableCell>
                              </>
                            )}

                            <TableCell>
                              <div className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn">
                                <IconButton
                                  onClick={() => this.togglePaymentsModal(enrollment)}
                                >
                                  <AccountBalanceWalletIcon
                                    style={{
                                      color: "#A2A5B5",
                                      fontSize: "20px",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </TableCell>

                            <TableCell className="tData">
                              {enrollment?.discount
                                ? `${enrollment.discount} %`
                                : "None"}
                            </TableCell>

                            <TableCell className="tData">
                              {this.amountToLRK(
                                this.calOutstandingAmount(
                                  this.state.amount?.amount,
                                  enrollment.total_amount,
                                  enrollment?.discount
                                )
                              )}
                            </TableCell>

                            <TableCell>
                              <div className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn">
                                <IconButton
                                  onClick={() => this.toggleDiscountModal(enrollment)}
                                >
                                  <EditNoteIcon
                                    style={{
                                      color: "#A2A5B5",
                                      fontSize: "20px",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </TableCell>

                            {/* -------------- NEW PRINT BUTTON (BODY) -------------- */}
                            <TableCell>
                              <Button
                                variant="primary"
                                className="insert-btn"
                                onClick={() => this.handlePrint(enrollment)}
                              >
                                Print
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                      <Modal
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={editEndDateModal}
                        onHide={this.toggleeditEndDateModal}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Edit due date</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                          {/* {this.state.loadingModal ? (
                            <Row className="justify-content-center align-items-center">
                              <Col xs={12} className="text-center">
                                <Spinner animation="border" role="status">
                                  <span className="sr-only">Loading...</span>
                                </Spinner>
                              </Col>
                            </Row>
                          ) : ( */}
                          <Form>
                            <Row className="my-5">
                              <Form.Group
                                as={Col}
                                md="12"
                                controlId="exampleForm.ControlInput1"
                              >
                                <Form.Label>Due Date</Form.Label>
                                {/* <div className="col-md-12 px-0"> */}

                                <DatePicker
                                  name="updated_end_date"
                                  selected={
                                    this.state.updated_end_date
                                      ? new Date(this.state.updated_end_date)
                                      : undefined
                                  }
                                  onChange={(date) =>
                                    this.handleDatePickerChange(
                                      date,
                                      "updated_end_date"
                                    )
                                  }
                                  dateFormat="dd-MM-yyyy h:mm aa" // Set custom date format
                                  placeholderText="Deadline"
                                  wrapperClassName="react-datePicker"
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  timeIntervals={15}
                                  // minDate={
                                  //   this.state.updated_end_date
                                  //     ? new Date(this.state.updated_end_date)
                                  //     : null
                                  // }
                                  minDate={new Date()}
                                  customInput={<CustomInput />}
                                />
                                <Button
                                  className="btn btn-icon btn-danger btn-sm m-1 flaticon-delete"
                                  title="Delete Feedback"
                                  onClick={this.resetDatePicker}
                                />
                                {/* </div> */}
                              </Form.Group>
                            </Row>
                          </Form>
                          {/* )} */}

                          <Modal.Footer>
                            <Button
                              sx={{ mr: "20px" }}
                              onClick={this.toggleeditEndDateModal}
                              className="modal-btn"
                              id="modal-close-button"
                            >
                              Close
                            </Button>
                            <Button
                              className="modal-btn"
                              variant="primary"
                              onClick={this.handleUpdate}
                            >
                              Save
                            </Button>
                          </Modal.Footer>
                        </Modal.Body>
                      </Modal>
                      <Modal
                        size="md"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={addEndDateModal}
                        onHide={this.toggleaddEndDateModal}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Add a due date</Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                          {/* {this.state.loadingModal ? (
                            <Row className="justify-content-center align-items-center">
                              <Col xs={12} className="text-center">
                                <Spinner animation="border" role="status">
                                  <span className="sr-only">Loading...</span>
                                </Spinner>
                              </Col>
                            </Row>
                          ) : ( */}
                          <Form>
                            <Row className="my-5">
                              <Form.Group
                                as={Col}
                                md="12"
                                controlId="exampleForm.ControlInput1"
                              >
                                <Form.Label>Due Date</Form.Label>
                                {/* <div className="col-md-12 px-0"> */}
                                <DatePicker
                                  className="py-2 form-control w-100 col-md-12"
                                  name="updated_end_date"
                                  selected={
                                    this.state.updated_end_date
                                      ? new Date(this.state.updated_end_date)
                                      : undefined
                                  }
                                  onChange={(date) =>
                                    this.handleDatePickerChange(
                                      date,
                                      "updated_end_date"
                                    )
                                  }
                                  dateFormat="dd-MM-yyyy h:mm aa" // Set custom date format
                                  placeholderText="Deadline"
                                  wrapperClassName="react-datePicker"
                                  showTimeSelect
                                  timeFormat="HH:mm"
                                  timeIntervals={15}
                                  // maxDate={(new Date(progress_details[progress_details.length - 1]?.end_date) > new Date()) ? new Date() :new Date(progress_details[progress_details.length - 1]?.end_date) }
                                  minDate={new Date()}
                                  customInput={<CustomInput />}
                                />
                                <Button
                                  className="btn btn-icon btn-danger btn-sm m-1 flaticon-delete"
                                  title="Delete Feedback"
                                  onClick={this.resetDatePicker}
                                />
                                {/* </div> */}
                              </Form.Group>
                            </Row>
                          </Form>
                          {/* )} */}

                          <Modal.Footer>
                            <Button
                              sx={{ mr: "20px" }}
                              onClick={this.toggleaddEndDateModal}
                              className="modal-btn"
                              id="modal-close-button"
                            >
                              Close
                            </Button>
                            <Button
                              className="modal-btn"
                              variant="primary"
                              onClick={this.handleAdd}
                            >
                              Save
                            </Button>
                          </Modal.Footer>
                        </Modal.Body>
                      </Modal>
                      {!user_list_restriction && (
                        <MaterialCustomTablePagination
                          totalCount={parseInt(totalEnrollments)}
                          currentPage={currentPage}
                          limit={limit}
                          handlePageChange={this.handlePageChange}
                          handleRowsPerPageChange={this.handleRowsPerPageChange}
                          handlePageOffsetChange={this.handlePageOffsetChange}
                          rowsPerPageOptions={[5, 10, 20]}
                          offset={offset}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <div className="text-center mb-5 mt-10">
                    <label>No User to Select </label>
                  </div>
                )}
              </CardBody>
            )}
          </div>
        </ContentWrapper>
        <Modal
          //   size="md"
          dialogClassName="modal-90w"
          aria-labelledby="contained-modal-title-vcenter"
          size="xl"
          centered
          show={this.state.showInsertModal}
          onHide={() =>
            this.setState({
              showInsertModal: false,
              payments: null,
              paymentLoading: true,
              enrollmentLoading: false,
              selectedStudent: undefined,
              paymentValue: undefined,
              paymentDescription: undefined,
              mannualReceptCode: undefined,
              payment_date: null,
              manualReceiptFiles: []
            })
          }
        >
          <Modal.Header closeButton>
            <Modal.Title>Payment Info</Modal.Title>
          </Modal.Header>
          {paymentLoading || enrollmentLoading ? (
            <div className="loading-container">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <Modal.Body>
              <>
                <h2 className="payment-total">
                  <div className=" d-flex justify-content-between">
                    <p style={{ fontSize: "15px" }}>Amount</p>
                    <p>{this.amountToLRK(this.state.amount?.amount)}</p>
                  </div>
                  <div className=" d-flex justify-content-between">
                    <p style={{ fontSize: "12px" }}>Applied Discount</p>
                    <p style={{ fontSize: "12px" }}>{`${this.state.selectedStudent?.discount
                      ? this.state.selectedStudent?.discount
                      : 0
                      } %`}</p>
                  </div>
                  <div className=" d-flex justify-content-between">
                    <p style={{ fontSize: "12px" }}>Discounted Amount</p>
                    <p style={{ fontSize: "12px" }}>
                      {this.amountToLRK(
                        (this.state.amount?.amount / 100) *
                        (this.state.selectedStudent?.discount
                          ? this.state.selectedStudent?.discount
                          : 0)
                      )}
                    </p>
                  </div>
                  <div className=" d-flex justify-content-between">
                    <p style={{ fontSize: "12px" }}>
                      Amount after discount applied
                    </p>
                    <p style={{ fontSize: "12px" }}>
                      {this.amountToLRK(
                        this.state.amount?.amount -
                        (this.state.amount?.amount / 100) *
                        (this.state.selectedStudent?.discount
                          ? this.state.selectedStudent?.discount
                          : 0)
                      )}
                    </p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p style={{ fontSize: "12px" }}>Due Date</p>
                    <p style={{ fontSize: "12px" }}>
                      <div className="row">
                        {this.state.amount?.due_date ? (
                          <>
                            <div>
                              {this.formattedDateString(
                                this.state.amount?.due_date
                              )}
                            </div>
                            &nbsp;
                            <div>
                              {this.formattedTimeString(
                                this.state.amount?.due_date
                              )}
                            </div>
                          </>
                        ) : (
                          "-"
                        )}
                      </div>
                    </p>
                  </div>
                </h2>

                <div className="row d-flex justify-content-between py-3 px-5 outstanding-total">
                  <p>Outstanding Amount</p>
                  <p>
                    <b>
                      {this.amountToLRK(
                        this.calOutstandingAmount(
                          this.state.amount?.amount,
                          this.totalPaid(),
                          this.state.selectedStudent?.discount
                        )
                      )}
                    </b>
                  </p>
                </div>
                <br />

                {addVisibility && (
                  <div className="row d-flex justify-content-between">
                    <div className="col-md-4 px-0 no-arrow">
                      <Dropdown data-bs-theme="dark">
                        <Dropdown.Toggle
                          id="dropdown-button-dark-example1"
                          variant="secondary"
                          style={{
                            width: "95%",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            fontFamily: "Poppins, sans-serif",
                            backgroundColor: "#fff",
                          }}
                        >
                          {!!this.state.selectedPaymentMethod
                            ? this.state.selectedPaymentMethod.name
                            : "Payment Method"}
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          style={{
                            maxHeight: "190px",
                            overflowY: "auto",
                            width: "100%",
                          }}
                        >
                          {this.state.paymentMethods?.map((meth) => (
                            <Dropdown.Item
                              key={meth.payment_method_id}
                              onClick={() =>
                                this.handlePaymentMethodSelect(meth)
                              }
                            >
                              <div className="col-6">{meth.name}</div>
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div className="col-md-8 col-12 px-0 no-arrow">
                      <TextField
                        size="small"
                        type="number"
                        placeholder="Enter Payment"
                        onChange={(e) => this.handlePaymentChange(e)}
                        variant="outlined"
                        value={this.state.paymentValue}
                        inputProps={{ min: 0 }}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="row col-12 px-0 d-flex justify-content-between">
                      <div className="col-md-6 my-2 px-0 no-arrow">
                        <TextField
                          size="small"
                          type="text"
                          placeholder="Manual Receipt Code"
                          onChange={(e) => this.handleManualReceptChange(e)}
                          variant="outlined"
                          value={this.state.mannualReceptCode}
                          style={{ width: "100%" }}
                        />
                      </div>
                      {/* File Input */}
                      <div className="col-md-6 my-2 px-0">
                        <div className="row justify-content-between">
                          <div>
                            <Button_M
                              variant="outlined"
                              component="label"
                              sx={{
                                width: '100%', cursor: 'pointer', mb: 2,
                                borderColor: '#B2BEB5',
                                color: '#B2BEB5',
                                '&:hover': {
                                  borderColor: '#A0A0A0',
                                  backgroundColor: 'rgba(178, 190, 181, 0.1)',
                                }
                              }}
                            >Upload
                              <input
                                ref={this.fileInputRef}
                                type="file"
                                name="manualReceiptFiles"
                                onChange={(e) => this.handleSelectedFiles(e)}
                                style={{ display: 'none' }}
                                multiple
                              />
                              <UploadFileIcon fontSize="large" />
                            </Button_M>
                          </div>
                          {!!this.state.manualReceiptFiles.length && <div className="row d-flex justify-content-between">
                            <div>Click to view the selected files</div>
                            <Tooltip title="click to view the selected files">
                              <IconButton
                                style={{
                                  color: "#A2A5B5",
                                  fontSize: "20px",
                                }}
                                onClick={() => {
                                  this.onToggleSelectedDocs(true)
                                }}
                              >
                                <RemoveRedEyeIcon fontSize="large" />
                              </IconButton>
                            </Tooltip>
                            {/* <Tooltip title= "click to clear selected files" >
                              <IconButton 
                                  style={{
                                    color: "#A2A5B5",
                                    fontSize: "20px",
                                  }}
                                  onClick={this.clearSelectedFiles}                            
                              >
                                <DeleteIcon fontSize="large" />
                              </IconButton>
                            </Tooltip>                                */}
                          </div>}
                        </div>
                      </div>
                      <div className="col-md-6 my-2 px-0 no-arrow">

                        <DatePicker
                          className="py-2 form-control" // Add Bootstrap form control class
                          selected={
                            this.state.payment_date
                              ? new Date(this.state.payment_date)
                              : undefined
                          }
                          name="payment_date"
                          onChange={this.handlePaymentDatePickerChange}
                          dateFormat="dd-MM-yyyy h:mm aa" // Set custom date format
                          placeholderText="Date"
                          timeFormat="HH:mm"
                          timeIntervals={15}
                          wrapperClassName="react-datePicker"
                          showTimeSelect={true}
                          showTimeInput

                        />
                      </div>
                    </div>

                    <div className="col-md-12 col-12 my-2 px-0 no-arrow">
                      <TextField
                        size="small"
                        type="text"
                        placeholder="Payment Description"
                        onChange={(e) => this.handlePaymentDescriptionChange(e)}
                        variant="outlined"
                        value={this.state.paymentDescription}
                        style={{ width: "100%" }}
                      />
                    </div>

                    <div className="w-100 d-flex justify-content-end">
                      <Button
                        className="insert-btn"
                        variant="primary"
                        disabled={this.state.paymentValue?.length < 1}
                        onClick={this.submitPayment}
                        style={{ height: "36px" }}
                      >
                        Add Payment
                      </Button>
                    </div>
                  </div>
                )}
              </>
              <h3>Payment History</h3>
              {payments?.length > 0 ? (
                <>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Date & Time</TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Orginal Payment Date</TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Receipt Code</TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Type</TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>
                          Manual Receipt Codep
                        </TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Amount</TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Description</TableCell>
                        <TableCell className="thead" style={{ textAlign: 'center' }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {payments?.map((payment) => {
                        return (
                          <TableRow key={payment.id}>
                            <TableCell style={{ textAlign: 'center' }}>
                              <div>
                                {this.formattedDateString(payment.created_at)
                                  ? this.formattedDateString(
                                    TimeZoneHandler.convertTime(
                                      payment.created_at
                                    )
                                  )
                                  : undefined}
                              </div>
                              <div>
                                {this.formattedTimeString(payment.created_at)
                                  ? this.formattedTimeString(
                                    TimeZoneHandler.convertTime(
                                      payment.created_at
                                    )
                                  )
                                  : undefined}
                              </div>
                            </TableCell>
                            <TableCell className="" style={{ textAlign: 'center' }}>
                              {payment?.payment_date ? TimeZoneHandler.convertTimeToCustomFormat(new Date(payment?.payment_date)) : undefined}
                            </TableCell>
                            <TableCell className="" style={{ textAlign: 'center' }}>
                              {payment?.recipt_code || "-"}
                            </TableCell>
                            <TableCell className="" style={{ textAlign: 'center' }}>
                              {payment?.payment_method}
                            </TableCell>
                            <TableCell className="" style={{ textAlign: 'center' }}>
                              {payment?.manual_recipt_code || "-"}
                            </TableCell>
                            <TableCell className="" style={{ textAlign: 'center' }}>
                              {this.amountToLRK(payment?.payment)}
                            </TableCell>
                            {
                              payment.description === this.truncateString(payment.description, 50) ?
                                <TableCell style={{ width: "20%", textAlign: 'center' }}>{payment.description}</TableCell> :
                                <TableCell style={{ width: "20%", textAlign: 'center', cursor: 'pointer' }}>
                                  <Tooltip title={payment.description}>
                                    <span> {this.truncateString(payment.description, 50)}</span>
                                  </Tooltip>
                                </TableCell>
                            }
                            {editVisibility && <TableCell className="">
                              <div className="btn btn-icon btn-primary btn-sm m-1 edit-assement-btn">
                                <IconButton
                                  onClick={() =>
                                    this.onToggleReceiptDoc(payment)
                                  }
                                >
                                  <EditNoteIcon
                                    style={{
                                      color: "#A2A5B5",
                                      fontSize: "20px",
                                    }}
                                  />
                                </IconButton>
                              </div>
                            </TableCell>}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                  <div className="row d-flex justify-content-between py-3 px-5 payment-total">
                    <p>Paid</p>
                    <p>
                      <b>{`${this.amountToLRK(this.totalPaid())}`}</b>
                    </p>
                  </div>
                  {/* <div className="row d-flex justify-content-between py-3 px-5 outstanding-total">
                    <p>Outstanding Amount</p>
                    <p>
                      <b>
                        {this.amountToLRK(
                          this.calOutstandingAmount(
                            this.state.amount?.amount,
                            this.totalPaid(),
                            this.state.selectedStudent?.discount
                          )
                        )}
                      </b>
                    </p>
                  </div> */}
                </>
              ) : (
                <div className="text-center mb-5 mt-10">
                  <label>No Payments Yet </label>
                </div>
              )}
              <h3>Other Enrollments</h3>
              {otherEnrollments.length > 0 ? (
                otherEnrollments.map((enrollment) => (
                  <p>
                    {enrollment.breadcrumb}
                    {enrollment.tree_main_title}
                  </p>
                ))
              ) : (
                <div className="text-center mb-5 mt-10">
                  <label>No Other Enrollments </label>
                </div>
              )}
            </Modal.Body>
          )}
          <Modal.Footer>
            <Button
              id="modal-close-button"
              style={closeBtnStyle}
              onClick={() =>
                this.setState({
                  showInsertModal: false,
                  payments: null,
                  paymentLoading: true,
                  enrollmentLoading: false,
                  selectedStudent: undefined,
                  paymentValue: undefined,
                  paymentDescription: undefined,
                  payment_date: null,
                  manualReceiptFiles: []
                })
              }
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
        {
          <DiscountModal
            calOutstandingAmount={(totalAmount, discount) => this.calOutstandingAmount(this.state.amount?.amount, totalAmount, discount)}
            editVisibility={editVisibility}
            showDiscountModal={this.state.showDiscountModal}
            toggleDiscountModal={this.toggleDiscountModal}
            selectedStudent={this.state.selectedStudent}
            closeBtnStyle={closeBtnStyle}
            state={this.props.state}
            getAllEnrollments={() => this.getAllEnrollments()}
            amount={this.state.amount?.amount}
          />
        }
        <ReceiptDocUpload
          editVisibility={editVisibility}
          showReceiptDoc={this.state.showReceiptDoc}
          onToggleReceiptDoc={this.onToggleReceiptDoc}
          selectedStudent={this.state.selectedStudent}
          closeBtnStyle={closeBtnStyle}
          state={this.props.state}
          container_id={this.state.container_id}
          onFileUpload={(func, manualReceiptFiles) => { this.onFileUpload(this.state.selectedStudent.user_code, func, manualReceiptFiles) }}
          getPayment={() => this.getPayment(this.state.selectedStudentId, this.props.state.mid)}
          setPayments={this.setPayments}
          payments={this.state.payments}
        />
        <SelecteDocsHandle
          showSelectedDocs={this.state.showSelectedDocs}
          onToggleSelectedDocs={this.onToggleSelectedDocs}
          manualReceiptFiles={this.state.manualReceiptFiles}
          removeSelectedDoc={this.removeSelectedDoc}
        />
      </div>
    );
  }
}
